/*
 * Copyright (C) 2021 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import formatMessage from '../../format-message';
import '../tinymce/ar_SA';
const locale = {
  "access_the_pretty_html_editor_37168efe": {
    "message": "الوصول إلى محرر HTML الأنيق"
  },
  "accessibility_checker_b3af1f6c": {
    "message": "المتحقق من إمكانية الوصول"
  },
  "action_to_take_b626a99a": {
    "message": "إجراء مقرر اتخاذه:"
  },
  "add_8523c19b": {
    "message": "إضافة"
  },
  "add_a_caption_2a915239": {
    "message": "إضافة تسمية توضيحية"
  },
  "add_alt_text_for_the_image_48cd88aa": {
    "message": "إضافة نص بديل للصورة"
  },
  "add_another_f4e50d57": {
    "message": "إضافة محتوى"
  },
  "add_cc_subtitles_55f0394e": {
    "message": "إضافة شرح مكتوب لأحداث العرض/أشرطة الترجمة"
  },
  "add_image_60b2de07": {
    "message": "إضافة صورة"
  },
  "add_one_9e34a6f8": {
    "message": "إضافة المزيد!"
  },
  "additional_considerations_f3801683": {
    "message": "الاعتبارات الإضافية"
  },
  "address_applied_64269b0b": {
    "message": "تم تطبيق العنوان"
  },
  "address_removed_fcb496e0": {
    "message": "تمت إزالة العنوان"
  },
  "adjacent_links_with_the_same_url_should_be_a_singl_7a1f7f6c": {
    "message": "يجب أن تكون الروابط المتجاورة بنفس عنوان URL رابطًا فرديًا."
  },
  "aleph_f4ffd155": {
    "message": "Aleph"
  },
  "align_11050992": {
    "message": "محاذاة"
  },
  "alignment_and_lists_5cebcb69": {
    "message": "المحاذاة والقوائم"
  },
  "all_4321c3a1": {
    "message": "الكل"
  },
  "all_apps_a50dea49": {
    "message": "كافة التطبيقات"
  },
  "allow_media_download_16dcf2bd": {
    "message": "السماح بتنزيل الوسائط"
  },
  "allow_transcript_download_3fa239f0": {
    "message": "السماح بتنزيل البرنامج النصي"
  },
  "alpha_15d59033": {
    "message": "Alpha"
  },
  "alphabetical_55b5b4e0": {
    "message": "أبجدي"
  },
  "alt_attribute_text_should_not_contain_more_than_12_e21d4040": {
    "message": "يجب ألا يتضمن نص السمة البديلة أكثر من 120 حرفًا."
  },
  "alt_text_611fb322": {
    "message": "النص البديل"
  },
  "amalg_coproduct_c589fb12": {
    "message": "Amalg (Coproduct)"
  },
  "an_error_occured_reading_the_file_ff48558b": {
    "message": "حدث خطأ أثناء قراءة الملف"
  },
  "an_error_occurred_making_a_network_request_d1bda348": {
    "message": "حدث خطأ أثناء إجراء طلب شبكة"
  },
  "an_error_occurred_uploading_your_media_71f1444d": {
    "message": "حدث خطأ أثناء تحميل الوسائط."
  },
  "and_7fcc2911": {
    "message": "و"
  },
  "angle_c5b4ec50": {
    "message": "زاوية"
  },
  "announcement_fb4cb645": {
    "message": "الإعلان"
  },
  "announcement_list_da155734": {
    "message": "قائمة الإعلانات"
  },
  "announcements_a4b8ed4a": {
    "message": "الإعلانات"
  },
  "apply_781a2546": {
    "message": "تطبيق"
  },
  "apply_changes_to_all_instances_of_this_icon_maker__2642f466": {
    "message": "تطبيق التغييرات على كافة مثيلات أيقونة صانع الأيقونات هذه في المساق"
  },
  "approaches_the_limit_893aeec9": {
    "message": "يقترب من الحد"
  },
  "approximately_e7965800": {
    "message": "تقريبًا"
  },
  "apps_54d24a47": {
    "message": "التطبيق"
  },
  "are_you_sure_you_want_to_cancel_changes_you_made_m_c5210496": {
    "message": "هل تريد الإلغاء بالفعل؟ قد لا يتم حفظ التغييرات التي أجريتها."
  },
  "arrows_464a3e54": {
    "message": "الأسهم"
  },
  "art_icon_8e1daad": {
    "message": "أيقونة الفنون"
  },
  "aspect_ratio_will_be_preserved_cb5fdfb8": {
    "message": "سيتم الاحتفاظ بنسبة العرض إلى الارتفاع"
  },
  "assignment_976578a8": {
    "message": "المهمة"
  },
  "assignments_1e02582c": {
    "message": "المهام"
  },
  "asterisk_82255584": {
    "message": "نجمة"
  },
  "attributes_963ba262": {
    "message": "السمات"
  },
  "audio_and_video_recording_not_supported_please_use_5ce3f0d7": {
    "message": "تسجيل الصوت والفيديو غير مدعوم، يرجى استخدام مستعرض مختلف."
  },
  "audio_options_feb58e2c": {
    "message": "خيارات الصوت"
  },
  "audio_options_tray_33a90711": {
    "message": "علبة خيارات الصوت"
  },
  "audio_player_for_title_20cc70d": {
    "message": "مشغل الصوت لـ { title }"
  },
  "auto_saved_content_exists_would_you_like_to_load_t_fee528f2": {
    "message": "المحتوى المحفوظ تلقائياً موجود. هل ترغب في تحميل المحتوى المحفوظ تلقائياً بدلاً من ذلك؟"
  },
  "available_folders_694d0436": {
    "message": "المجلدات المتاحة"
  },
  "background_1bc88842": {
    "message": "الخلفية"
  },
  "backslash_b2d5442d": {
    "message": "شرطة مائلة للخلف"
  },
  "bar_ec63ed6": {
    "message": "شريط"
  },
  "basic_554cdc0a": {
    "message": "أساسي"
  },
  "because_501841b": {
    "message": "لأن"
  },
  "below_81d4dceb": {
    "message": "الأسفل"
  },
  "beta_cb5f307e": {
    "message": "Beta"
  },
  "big_circle_16b2e604": {
    "message": "دائرة كبيرة"
  },
  "binomial_coefficient_ea5b9bb7": {
    "message": "معامل ثنائي الحد"
  },
  "black_4cb01371": {
    "message": "أسود"
  },
  "blue_daf8fea9": {
    "message": "أزرق"
  },
  "bold_applied_42d547b7": {
    "message": "تم تطبيق الخط الغامق"
  },
  "bold_removed_da474a5c": {
    "message": "تمت إزالة الخط الغامق"
  },
  "border_5b08b06d": {
    "message": "الحد"
  },
  "bottom_15a2a9be": {
    "message": "أسفل"
  },
  "bottom_third_5f5fec1d": {
    "message": "الثالث من الأسفل"
  },
  "bowtie_5f9629e4": {
    "message": "ربطة قوسية"
  },
  "brick_f2656265": {
    "message": "قرميد"
  },
  "c_2001_acme_inc_283f7f80": {
    "message": "(c) 2001 Acme Inc."
  },
  "cancel_caeb1e68": {
    "message": "إلغاء"
  },
  "cap_product_3a5265a6": {
    "message": "Cap Product"
  },
  "caption_manager_aae0906f": {
    "message": "مدير التعليق التوضيحي"
  },
  "center_align_e68d9997": {
    "message": "محاذاة إلى الوسط"
  },
  "centered_dot_64d5e378": {
    "message": "نقطة مركزية"
  },
  "centered_horizontal_dots_451c5815": {
    "message": "نقاط أفقية مركزية"
  },
  "change_alt_text_92654906": {
    "message": "تغيير النص البديل"
  },
  "change_heading_tag_to_paragraph_a61e3113": {
    "message": "تغيير علامة العنوان إلى فقرة"
  },
  "change_only_this_heading_s_level_903cc956": {
    "message": "تغيير مستوى هذا العنوان فقط"
  },
  "change_text_color_1aecb912": {
    "message": "تغيير لون النص"
  },
  "changes_will_apply_after_you_save_this_page_fb324e9d": {
    "message": "سيتم تطبيق التغييرات بعد حفظ هذه الصفحة."
  },
  "changes_you_made_may_not_be_saved_4e8db973": {
    "message": "قد لا يتم حفظ التغييرات التي أجريتها."
  },
  "characters_9d897d1c": {
    "message": "أحرف"
  },
  "characters_no_spaces_485e5367": {
    "message": "الأحرف (بدون مسافات)"
  },
  "check_accessibility_3c78211c": {
    "message": "التحقق من إمكانية الوصول"
  },
  "checking_for_accessibility_issues_fac18c6d": {
    "message": "التحقق من مشاكل إمكانية الوصول"
  },
  "chi_54a32644": {
    "message": "Chi"
  },
  "choose_caption_file_9c45bc4e": {
    "message": "اختر ملف تسميات توضيحية"
  },
  "choose_usage_rights_33683854": {
    "message": "اختر حقوق الاستخدام..."
  },
  "circle_484abe63": {
    "message": "الدائرة"
  },
  "circle_unordered_list_9e3a0763": {
    "message": "قائمة دائرية غير المرتبة"
  },
  "clear_2084585f": {
    "message": "مسح"
  },
  "clear_image_3213fe62": {
    "message": "مسح الصورة"
  },
  "click_or_shift_click_for_the_html_editor_25d70bb4": {
    "message": "انقر أو نقرة + shift للوصول إلى محرر html."
  },
  "click_to_embed_imagename_c41ea8df": {
    "message": "انقر لتضمين { imageName }"
  },
  "click_to_hide_preview_3c707763": {
    "message": "انقر لإخفاء المعاينة"
  },
  "click_to_insert_a_link_into_the_editor_c19613aa": {
    "message": "انقر لإدراج ارتباط إلى المحرر."
  },
  "click_to_show_preview_faa27051": {
    "message": "انقر لإظهار المعاينة"
  },
  "close_a_menu_or_dialog_also_returns_you_to_the_edi_739079e6": {
    "message": "إغلاق قائمة أو مربع حوار. يعيدك أيضًا إلى مساحة المحرر"
  },
  "close_accessibility_checker_29d1c51e": {
    "message": "إغلاق المتحقق من إمكانية الوصول"
  },
  "close_d634289d": {
    "message": "إغلاق"
  },
  "close_keyboard_shortcuts_modal_291ce074": {
    "message": "إغلاق مربع حوار اختصارات لوحة المفاتيح"
  },
  "closed_caption_file_must_be_less_than_maxkb_kb_5880f752": {
    "message": "يجب أن يقل حجم ملف التسمية التوضيحية المغلقة عن { maxKb } كيلوبايت"
  },
  "closed_captions_subtitles_e6aaa016": {
    "message": "تسميات توضيحية مغلقة/ترجمات مباشرة"
  },
  "clubs_suit_c1ffedff": {
    "message": "Clubs (Suit)"
  },
  "collab_575ac7bc": {
    "message": "التعاون"
  },
  "collaborations_5c56c15f": {
    "message": "الأعمال الجماعية"
  },
  "collapse_to_hide_types_1ab46d2e": {
    "message": "الطي لإخفاء { types }"
  },
  "color_a363e1b0": {
    "message": "اللون"
  },
  "color_contrast_4c418add": {
    "message": "تباين الألوان"
  },
  "color_contrast_ratio_687782f0": {
    "message": "نسبة تباين الألوان"
  },
  "color_picker_6b359edf": {
    "message": "أداة انتقاء اللون"
  },
  "color_picker_colorname_selected_ad4cf400": {
    "message": "أداة انتقاء اللون (تم تحديد { colorName })"
  },
  "color_popup_af39810f": {
    "message": "نافذة منبثقة ملونة"
  },
  "column_e1ae5c64": {
    "message": "عمود"
  },
  "column_group_1c062368": {
    "message": "مجموعة العمود"
  },
  "complex_numbers_a543d004": {
    "message": "أعداد مركبة"
  },
  "computer_1d7dfa6f": {
    "message": "الكمبيوتر"
  },
  "congruent_5a244acd": {
    "message": "Congruent"
  },
  "contains_311f37b7": {
    "message": "يحتوي على"
  },
  "content_1440204b": {
    "message": "المحتوى"
  },
  "content_in_the_editor_will_be_changed_press_cancel_d5bf3357": {
    "message": "سيتغير المحتوى في المحرر. اضغط على إلغاء للاحتفاظ بالمحتوى الأصلي."
  },
  "content_is_still_being_uploaded_if_you_continue_it_8f06d0cb": {
    "message": "لا يزال يتم تحميل المحتوى، إذا استمرت مشكلة عدم تضمين المحتوى بشكل سليم."
  },
  "content_subtype_5ce35e88": {
    "message": "النوع الفرعي للمحتوى"
  },
  "content_type_2cf90d95": {
    "message": "نوع المحتوى"
  },
  "continue_to_youtube_content_a34f0f85": {
    "message": "المتابعة إلى محتوى YouTube"
  },
  "coproduct_e7838082": {
    "message": "منتج مشترك"
  },
  "copyright_holder_66ee111": {
    "message": "مالك حق النشر:"
  },
  "could_not_insert_content_itemtype_items_are_not_cu_638dfecd": {
    "message": "تعذر إدراج المحتوى: عناصر \"{ itemType }\" غير مدعومة حاليًا في Canvas."
  },
  "count_40eced3b": {
    "message": "العدد"
  },
  "count_plural_0_0_words_one_1_word_other_words_acf32eca": {
    "message": "{ count, plural,\n     =0 {0 كلمات}\n    one {1 كلمة}\n  other {# من الكلمات}\n}"
  },
  "count_plural_one_item_loaded_other_items_loaded_857023b7": {
    "message": "{ count, plural,\n    one {# عنصر محمّل}\n  other {# من العناصر محمّلة}\n}"
  },
  "course_documents_104d76e0": {
    "message": "مستندات المساق"
  },
  "course_files_62deb8f8": {
    "message": "ملفات المساق"
  },
  "course_files_a31f97fc": {
    "message": "ملفات المساق"
  },
  "course_images_f8511d04": {
    "message": "صور المساق"
  },
  "course_link_b369426": {
    "message": "رابط المساق"
  },
  "course_links_b56959b9": {
    "message": "روابط المساق"
  },
  "course_media_ec759ad": {
    "message": "وسائط المساق"
  },
  "course_navigation_dd035109": {
    "message": "التنقل عبر المساق"
  },
  "create_icon_110d6463": {
    "message": "إنشاء أيقونة"
  },
  "create_icon_maker_icon_c716bffe": {
    "message": "إنشاء أيقونة صانع الأيقونات"
  },
  "creative_commons_license_725584ae": {
    "message": "ترخيص المشاع الإبداعي:"
  },
  "crop_image_41bf940c": {
    "message": "قص الصورة"
  },
  "crop_image_807ebb08": {
    "message": "قص صورة"
  },
  "cup_product_14174434": {
    "message": "Cup Product"
  },
  "current_image_f16c249c": {
    "message": "الصورة الحالية"
  },
  "current_link_945a47ee": {
    "message": "الارتباط الحالي"
  },
  "current_volume_level_c55ab825": {
    "message": "مستوى الصوت الحالي"
  },
  "custom_6979cd81": {
    "message": "مخصص"
  },
  "cyan_c1d5f68a": {
    "message": "سماوي"
  },
  "dagger_57e0f4e5": {
    "message": "Dagger"
  },
  "date_added_ed5ad465": {
    "message": "تاريخ الإضافة"
  },
  "decorative_icon_9a7f3fc3": {
    "message": "أيقونة زينة"
  },
  "decorative_image_fde98579": {
    "message": "صورة تزيين"
  },
  "decorative_type_upper_f2c95e3": {
    "message": "{ TYPE_UPPER } زينة"
  },
  "decrease_indent_d9cf469d": {
    "message": "تقليل المسافة البادئة"
  },
  "decrease_rich_content_area_82068f64": {
    "message": "تقليل منطقة محتوى النص المنسق"
  },
  "deep_purple_bb3e2907": {
    "message": "أرجواني داكن"
  },
  "default_9db103d": {
    "message": "افتراضي"
  },
  "default_bulleted_unordered_list_47079da8": {
    "message": "قائمة افتراضية غير مرتبة بتعداد نقطي"
  },
  "default_numerical_ordered_list_48dd3548": {
    "message": "قائمة افتراضية مرقمة غير مرتبة"
  },
  "definite_integral_fe7ffed1": {
    "message": "قيمة التكامل المحدد"
  },
  "degree_symbol_4a823d5f": {
    "message": "رمز الدرجة"
  },
  "delimiters_4db4840d": {
    "message": "المحدِدات"
  },
  "delta_53765780": {
    "message": "Delta"
  },
  "describe_the_icon_f6a18823": {
    "message": "(وصف الصورة)"
  },
  "describe_the_type_ff448da5": {
    "message": "(اذكر وصفًا لـ { TYPE })"
  },
  "description_436c48d7": {
    "message": "الوصف"
  },
  "details_98a31b68": {
    "message": "التفاصيل"
  },
  "diagonal_dots_7d71b57e": {
    "message": "نقاط قطرية"
  },
  "diamond_b8dfe7ae": {
    "message": "معيّن"
  },
  "diamonds_suit_526abaaf": {
    "message": "Diamonds (Suit)"
  },
  "digamma_258ade94": {
    "message": "Digamma"
  },
  "dimension_type_f5fa9170": {
    "message": "نوع البعد"
  },
  "directionality_26ae9e08": {
    "message": "الاتجاهية"
  },
  "directly_edit_latex_b7e9235b": {
    "message": "تحرير LaTeX مباشرةً"
  },
  "disable_preview_222bdf72": {
    "message": "تعطيل المعاينة"
  },
  "discussion_6719c51d": {
    "message": "النقاش"
  },
  "discussions_a5f96392": {
    "message": "النقاشات"
  },
  "discussions_index_6c36ced": {
    "message": "فهرس المناقشات"
  },
  "disjoint_union_e74351a8": {
    "message": "Disjoint Union"
  },
  "display_options_315aba85": {
    "message": "عرض الخيارات"
  },
  "display_text_link_opens_in_a_new_tab_75e9afc9": {
    "message": "عرض ارتباط النص (يفتح في علامة تبويب جديدة)"
  },
  "div_applied_49ad83fc": {
    "message": "تم تطبيق Div"
  },
  "div_removed_d13f8e17": {
    "message": "تمت إزالة Div"
  },
  "division_sign_72190870": {
    "message": "علامة القسمة"
  },
  "document_678cd7bf": {
    "message": "مستند"
  },
  "documents_81393201": {
    "message": "المستندات"
  },
  "done_54e3d4b6": {
    "message": "تم"
  },
  "double_dagger_faf78681": {
    "message": "Double Dagger"
  },
  "down_5831a426": {
    "message": "لأسفل"
  },
  "down_and_left_diagonal_arrow_40ef602c": {
    "message": "سهم قطري لأسفل ويسار"
  },
  "down_and_right_diagonal_arrow_6ea0f460": {
    "message": "سهم قطري لأسفل ويمين"
  },
  "download_filename_2baae924": {
    "message": "تنزيل { filename }"
  },
  "downward_arrow_cca52012": {
    "message": "سهم لأسفل"
  },
  "downward_pointing_triangle_2a12a601": {
    "message": "مثلث يشير لأسفل"
  },
  "drag_a_file_here_1bf656d5": {
    "message": "إفلات ملف هنا"
  },
  "drag_and_drop_or_click_to_browse_your_computer_60772d6d": {
    "message": "اسحب وأفلت أو انقر لاستعراض الكمبيوتر الخاص بك"
  },
  "drag_handle_use_up_and_down_arrows_to_resize_e29eae5c": {
    "message": "إفلات المؤشر. استخدم سهمي لأعلى ولأسفل لضبط الحجم"
  },
  "due_multiple_dates_cc0ee3f5": {
    "message": "تاريخ الاستحقاق: تواريخ متعددة"
  },
  "due_when_7eed10c6": {
    "message": "تاريخ الاستحقاق: { when }"
  },
  "edit_alt_text_for_this_icon_instance_9c6fc5fd": {
    "message": "تحرير نصًا بديلًا لمثيل الأيقونة هذا"
  },
  "edit_c5fbea07": {
    "message": "تحرير"
  },
  "edit_course_link_5a5c3c59": {
    "message": "تحرير ارتباط المساق"
  },
  "edit_equation_f5279959": {
    "message": "تحرير المعادلة"
  },
  "edit_existing_icon_maker_icon_5d0ebb3f": {
    "message": "تحرير أيقونة صانع الأيقونات"
  },
  "edit_icon_2c6b0e91": {
    "message": "تحرير الأيقونة"
  },
  "edit_link_7f53bebb": {
    "message": "تحرير الارتباط"
  },
  "editor_status_bar_653f44ee": {
    "message": "شريط حالة المحرر"
  },
  "element_starting_with_start_91bf4c3b": {
    "message": "عنصر يبدأ بـ { start }"
  },
  "embed_828fac4a": {
    "message": "تضمين"
  },
  "embed_code_314f1bd5": {
    "message": "تضمين تعليمات برمجية"
  },
  "embed_content_from_external_tool_3397ad2d": {
    "message": "تضمين محتوى من الأداة الخارجية"
  },
  "embed_image_1080badc": {
    "message": "تضمين صورة"
  },
  "embed_video_a97a64af": {
    "message": "تضمين الفيديو"
  },
  "embedded_content_aaeb4d3d": {
    "message": "مضمّن آخر"
  },
  "empty_set_91a92df4": {
    "message": "مجموعة فارغة"
  },
  "encircled_dot_8f5e51c": {
    "message": "نقطة مطوقة"
  },
  "encircled_minus_72745096": {
    "message": "سالب مطوق"
  },
  "encircled_plus_36d8d104": {
    "message": "زائد مطوق"
  },
  "encircled_times_5700096d": {
    "message": "أوقات مطوقة"
  },
  "engineering_icon_f8f3cf43": {
    "message": "أيقونة الهندسة"
  },
  "english_icon_25bfe845": {
    "message": "أيقونة الإنجليزية"
  },
  "enter_a_media_title_81b490ec": {
    "message": "أدخل عنوان الوسيط"
  },
  "enter_at_least_3_characters_to_search_4f037ee0": {
    "message": "أدخل 3 أحرف على الأقل للبحث"
  },
  "enter_replacement_text_17631bbc": {
    "message": "أدخل نص استبدال"
  },
  "enter_search_text_26cb4459": {
    "message": "أدخل نص البحث"
  },
  "epsilon_54bb8afa": {
    "message": "Epsilon"
  },
  "epsilon_variant_d31f1e77": {
    "message": "Epsilon (متغير)"
  },
  "equals_sign_c51bdc58": {
    "message": "علامة يساوي"
  },
  "equation_1c5ac93c": {
    "message": "المعادلة"
  },
  "equation_editor_39fbc3f1": {
    "message": "محرر المعادلات"
  },
  "equilibrium_6ff3040b": {
    "message": "التعادل"
  },
  "equivalence_class_7b0f11c0": {
    "message": "فئة تكافؤ"
  },
  "equivalent_identity_654b3ce5": {
    "message": "مكافئ (هوية)"
  },
  "eta_b8828f99": {
    "message": "Eta"
  },
  "exists_2e62bdaa": {
    "message": "موجود"
  },
  "exit_fullscreen_b7eb0aa4": {
    "message": "الخروج من عرض ملء الشاشة"
  },
  "expand_preview_by_default_2abbf9f8": {
    "message": "توسيع المعاينة افتراضيًا"
  },
  "expand_to_see_types_f5d29352": {
    "message": "التوسيع لرؤية { types }"
  },
  "external_link_d3f9e62a": {
    "message": "الرابط الخارجي"
  },
  "external_tool_frame_70b32473": {
    "message": "إطار الأداة الخارجية"
  },
  "external_tools_6e77821": {
    "message": "الأدوات الخارجية"
  },
  "extra_large_b6cdf1ff": {
    "message": "كبير جداً"
  },
  "extra_large_width_x_height_px_915571fa": {
    "message": "كبير جدًا ({ width } × { height } بكسل)"
  },
  "extra_small_9ae33252": {
    "message": "صغير للغاية"
  },
  "extracurricular_icon_67c8ca42": {
    "message": "أيقونة الأنشطة غير الصفية"
  },
  "f_function_fe422d65": {
    "message": "F (دالة)"
  },
  "fail_544e5dde": {
    "message": "فشل"
  },
  "failed_getting_file_contents_e9ea19f4": {
    "message": "تعذر الحصول على محتويات الملف"
  },
  "failed_to_retrieve_content_from_external_tool_5899c213": {
    "message": "تعذر استرداد المحتوى من الأداة الخارجية"
  },
  "file_name_8fd421ff": {
    "message": "اسم الملف"
  },
  "file_preview_21667a6e": {
    "message": "معاينة الملف"
  },
  "file_preview_for_filename_ab314195": {
    "message": "معاينة الملف لـ { fileName }"
  },
  "file_storage_quota_exceeded_b7846cd1": {
    "message": "تم تجاوز حصة تخزين الملفات"
  },
  "file_url_c12b64be": {
    "message": "عنوان URL للملف"
  },
  "filename_file_icon_602eb5de": {
    "message": "أيقونة الملف { filename }"
  },
  "filename_image_preview_6cef8f26": {
    "message": "معاينة الصورة { filename }"
  },
  "filename_text_preview_e41ca2d8": {
    "message": "معاينة النص { filename }"
  },
  "files_c300e900": {
    "message": "الملفات"
  },
  "files_index_af7c662b": {
    "message": "فهرس الملفات"
  },
  "find_8d605019": {
    "message": "بحث"
  },
  "find_and_replace_6e345933": {
    "message": "بحث واستبدال"
  },
  "finish_bc343002": {
    "message": "إنهاء"
  },
  "fix_heading_hierarchy_f60884c4": {
    "message": "إصلاح هيكل العنوان"
  },
  "flat_music_76d5a5c3": {
    "message": "Flat (موسيقى)"
  },
  "focus_element_options_toolbar_18d993e": {
    "message": "شريط أدوات خيارات عنصر التركيز"
  },
  "folder_tree_fbab0726": {
    "message": "شجرة المجلد"
  },
  "for_all_b919f972": {
    "message": "للكل"
  },
  "format_4247a9c5": {
    "message": "التنسيق"
  },
  "format_as_a_list_142210c3": {
    "message": "التنسيق في صورة قائمة"
  },
  "formatting_5b143aa8": {
    "message": "التنسيق"
  },
  "forward_slash_3f90f35e": {
    "message": "شرطة للأمام"
  },
  "found_auto_saved_content_3f6e4ca5": {
    "message": "تم العثور على محتوى محفوظ تلقائياً"
  },
  "found_count_plural_0_results_one_result_other_resu_46aeaa01": {
    "message": "تم العثور على { count, plural,\n     =0 {# من النتائج}\n    one {# نتيجة}\n  other {# من النتائج}\n}"
  },
  "fraction_41bac7af": {
    "message": "كسر"
  },
  "fullscreen_873bf53f": {
    "message": "ملء الشاشة"
  },
  "gamma_1767928": {
    "message": "Gamma"
  },
  "generating_preview_45b53be0": {
    "message": "جارٍ إنشاء المعاينة..."
  },
  "gif_png_format_images_larger_than_size_kb_are_not__7af3bdbd": {
    "message": "الصور بتنسيق GIF/PNG أكبر من { size } كيلوبايت غير مدعومة حاليًا."
  },
  "go_to_the_editor_s_menubar_e6674c81": {
    "message": "الانتقال إلى شريط القوائم الخاص بالمحرر"
  },
  "go_to_the_editor_s_toolbar_a5cb875f": {
    "message": "الانتقال إلى شريط الأدوات الخاص بالمحرر"
  },
  "grades_a61eba0a": {
    "message": "الدرجات"
  },
  "graphics_text_bc9568bc": {
    "message": "نص الرسومات"
  },
  "greater_than_e98af662": {
    "message": "أكبر من"
  },
  "greater_than_or_equal_b911949a": {
    "message": "أكثر من أو يساوي"
  },
  "greek_65c5b3f7": {
    "message": "اليونانية"
  },
  "green_15af4778": {
    "message": "أخضر"
  },
  "grey_a55dceff": {
    "message": "رمادي"
  },
  "group_documents_8bfd6ae6": {
    "message": "مستندات المجموعة"
  },
  "group_files_4324f3df": {
    "message": "ملفات المجموعة"
  },
  "group_files_82e5dcdb": {
    "message": "ملفات المجموعة"
  },
  "group_images_98e0ac17": {
    "message": "صور المجموعة"
  },
  "group_isomorphism_45b1458c": {
    "message": "تساوي شكل المجموعة"
  },
  "group_link_63e626b3": {
    "message": "رابط المجموعة"
  },
  "group_links_9493129e": {
    "message": "تجميع الارتباطات"
  },
  "group_media_2f3d128a": {
    "message": "وسائط المجموعة"
  },
  "group_navigation_99f191a": {
    "message": "التنقل عبر المجموعة"
  },
  "h_bar_bb94deae": {
    "message": "شريط H"
  },
  "hat_ea321e35": {
    "message": "قبعة"
  },
  "header_column_f27433cb": {
    "message": "عمود الرأس"
  },
  "header_row_and_column_ec5b9ec": {
    "message": "صف وعمود الرأس"
  },
  "header_row_f33eb169": {
    "message": "صف الرأس"
  },
  "heading_2_5b84eed2": {
    "message": "العنوان 2"
  },
  "heading_3_2c83de44": {
    "message": "العنوان 3"
  },
  "heading_4_b2e74be7": {
    "message": "العنوان 4"
  },
  "heading_h_applied_eccd294d": {
    "message": "تم تطبيق العنوان { h }"
  },
  "heading_h_removed_745f24a6": {
    "message": "تمت إزالة العنوان { h }"
  },
  "heading_levels_should_not_be_skipped_3947c0e0": {
    "message": "يجب ألا يتم تجاوز مستويات العنوان."
  },
  "heading_starting_with_start_42a3e7f9": {
    "message": "يبدأ العنوان بـ { start }"
  },
  "headings_should_not_contain_more_than_120_characte_3c0e0cb3": {
    "message": "يجب ألا تتضمن العناوين أكثر من 120 حرفًا."
  },
  "health_icon_8d292eb5": {
    "message": "أيقونة الصحة"
  },
  "hearts_suit_e50e04ca": {
    "message": "Hearts (Suit)"
  },
  "height_69b03e15": {
    "message": "الارتفاع"
  },
  "hexagon_d8468e0d": {
    "message": "سداسي"
  },
  "hide_description_bfb5502e": {
    "message": "إخفاء الوصف"
  },
  "hide_title_description_caf092ef": {
    "message": "إخفاء وصف { title }"
  },
  "highlight_an_element_to_activate_the_element_optio_60e1e56b": {
    "message": "تمييز عنصر لتنشيط شريط أدوات خيارات العناصر"
  },
  "home_351838cd": {
    "message": "الصفحة الرئيسية"
  },
  "how_to_request_and_edit_captions_a49a9c6b": {
    "message": "كيف يتم طلب التعليقات التوضيحية وتحريرها؟"
  },
  "html_code_editor_fd967a44": {
    "message": "محرر التعليمات البرمجية HTML"
  },
  "html_editor_fb2ab713": {
    "message": "محرر HTML"
  },
  "i_have_obtained_permission_to_use_this_file_6386f087": {
    "message": "لقد حصلت على إذن لاستخدام هذا الملف."
  },
  "i_hold_the_copyright_71ee91b1": {
    "message": "أمتلك حق النشر"
  },
  "icon_215a1dc6": {
    "message": "الأيقونة"
  },
  "icon_8168b2f8": {
    "message": "الأيقونة"
  },
  "icon_color_b86dd6d6": {
    "message": "لون الأيقونة"
  },
  "icon_maker_icons_cc560f7e": {
    "message": "أيقونات صانع الأيقونات"
  },
  "icon_options_7e32746e": {
    "message": "خيارات الأيقونة"
  },
  "icon_options_tray_2b407977": {
    "message": "علبة خيارات الأيقونة"
  },
  "icon_preview_1782a1d9": {
    "message": "معاينة الأيقونة"
  },
  "icon_shape_30b61e7": {
    "message": "شكل الأيقونة"
  },
  "icon_size_9353edea": {
    "message": "حجم الأيقونة"
  },
  "if_left_empty_link_text_will_display_as_course_lin_2a34eedb": {
    "message": "إذا ترك الارتباط فارغًا، سيُعرض النص كاسم ارتباط مساق"
  },
  "if_usage_rights_are_required_the_file_will_not_pub_841e276e": {
    "message": "إذا تتطلب الأمر حقوق استخدام، لن يتم نشر الملف حتى تمكينه في صفحة الملفات."
  },
  "if_you_do_not_select_usage_rights_now_this_file_wi_14e07ab5": {
    "message": "إن لم تحدد الآن حقوق الاستخدام، فسيتم إلغاء نشر هذا الملف بعد تحميله."
  },
  "image_8ad06": {
    "message": "صورة"
  },
  "image_c1c98202": {
    "message": "صورة"
  },
  "image_filenames_should_not_be_used_as_the_alt_attr_bcfd7780": {
    "message": "يجب ألا يتم استخدام أسماء ملفات الصور كسمة ببديلة لوصف محتوى الصورة."
  },
  "image_options_5412d02c": {
    "message": "خيارات الصورة"
  },
  "image_options_tray_90a46006": {
    "message": "علبة خيارات الصورة"
  },
  "image_to_crop_3a34487d": {
    "message": "الصور المراد قصها"
  },
  "image_with_filename_file_aacd7180": {
    "message": "صورة باسم الملف { file }"
  },
  "images_7ce26570": {
    "message": "الصور"
  },
  "images_should_include_an_alt_attribute_describing__b86d6a86": {
    "message": "يجب أن تتضمن الصور سمة بديلة تصف محتوى الصورة."
  },
  "imaginary_portion_of_complex_number_2c733ffa": {
    "message": "الجزء التخيلي (من العدد المركب)"
  },
  "in_element_of_19ca2f33": {
    "message": "In (Element Of)"
  },
  "increase_indent_6af90f7c": {
    "message": "زيادة المسافة البادئة"
  },
  "increase_rich_content_area_340b775": {
    "message": "زيادة منطقة محتوى النص المنسق"
  },
  "indefinite_integral_6623307e": {
    "message": "قيمة التكامل غير المحدد"
  },
  "index_of_max_80dcf7a5": {
    "message": "{ index } من { max }"
  },
  "indigo_2035fc55": {
    "message": "نيلي"
  },
  "inference_fed5c960": {
    "message": "الاستنتاج"
  },
  "infinity_7a10f206": {
    "message": "ما لا نهاية"
  },
  "input_field_for_alpha_678265fd": {
    "message": "حقل الإدخال لألفا"
  },
  "input_field_for_blue_561e020a": {
    "message": "حقل الإدخال للون الأزرق"
  },
  "input_field_for_green_67f8b2b6": {
    "message": "حقل الإدخال للون الأخضر"
  },
  "input_field_for_red_86a84615": {
    "message": "حقل الإدخال للون الأحمر"
  },
  "insert_593145ef": {
    "message": "إدخال"
  },
  "insert_link_6dc23cae": {
    "message": "إدراج ارتباط"
  },
  "insert_math_equation_57c6e767": {
    "message": "إدخال معادلة رياضية"
  },
  "integers_336344e1": {
    "message": "أعداد صحيحة"
  },
  "intersection_cd4590e4": {
    "message": "تقاطع"
  },
  "invalid_description_991e23bb": {
    "message": "وصف غير صالح"
  },
  "invalid_entry_f7d2a0f5": {
    "message": "إدخال غير صالح."
  },
  "invalid_file_c11ba11": {
    "message": "ملف غير صالح"
  },
  "invalid_file_type_881cc9b2": {
    "message": "نوع ملف غير صالح"
  },
  "invalid_url_cbde79f": {
    "message": "URL غير صالح"
  },
  "iota_11c932a9": {
    "message": "Iota"
  },
  "issue_num_total_f94536cf": {
    "message": "مشكلة { num }/{ total }"
  },
  "italic_applied_8f59a684": {
    "message": "تم تطبيق الخط المائل"
  },
  "italic_removed_17cbab6f": {
    "message": "تمت إزالة الخط المائل"
  },
  "kappa_2f14c816": {
    "message": "Kappa"
  },
  "kappa_variant_eb64574b": {
    "message": "Kappa (متغير)"
  },
  "keyboard_shortcuts_ed1844bd": {
    "message": "اختصارات لوحة المفاتيح"
  },
  "keyboards_navigate_to_links_using_the_tab_key_two__5fab8c82": {
    "message": "تنتقل لوحات المفاتيح إلى الروابط باستخدام المفتاح Tab. يمكن أن يسبب رابطان متجاوران يوجهان إلى نفس الوجهة في إرباك مستخدمي لوحة المفاتيح."
  },
  "lambda_4f602498": {
    "message": "Lambda"
  },
  "language_arts_icon_a798b0f8": {
    "message": "أيقونة آداب اللغة"
  },
  "languages_icon_9d20539": {
    "message": "أيقونة اللغات"
  },
  "large_9c5e80e7": {
    "message": "كبير"
  },
  "large_text_e7ba08cd": {
    "message": "نص كبير"
  },
  "large_width_x_height_px_c61c2fd": {
    "message": "كبير ({ width } × { height } بكسل)"
  },
  "learn_ad3b3505": {
    "message": "تعلم"
  },
  "learn_more_about_adjacent_links_2cb9762c": {
    "message": "معرفة المزيد عن الارتباطات المتجاورة"
  },
  "learn_more_about_color_contrast_c019dfb9": {
    "message": "معرفة المزيد عن تباين اللون"
  },
  "learn_more_about_organizing_page_headings_8a7caa2e": {
    "message": "معرفة المزيد عن تنظيم عناوين الصفحات"
  },
  "learn_more_about_proper_page_heading_structure_d2959f2d": {
    "message": "معرفة المزيد عن الهيكل الملائم لعناوين الصفحات"
  },
  "learn_more_about_table_headers_5f5ee13": {
    "message": "معرفة المزيد عن رؤوس الجداول"
  },
  "learn_more_about_using_alt_text_for_images_5698df9a": {
    "message": "معرفة المزيد عن استخدام النص البديل للصور"
  },
  "learn_more_about_using_captions_with_tables_36fe496f": {
    "message": "معرفة المزيد عن استخدام التسميات التوضيحية مع الجداول"
  },
  "learn_more_about_using_filenames_as_alt_text_264286af": {
    "message": "معرفة المزيد عن استخدام أسماء الملفات كنصوص بديلة"
  },
  "learn_more_about_using_lists_4e6eb860": {
    "message": "معرفة المزيد عن استخدام القوائم"
  },
  "learn_more_about_using_scope_attributes_with_table_20df49aa": {
    "message": "معرفة المزيد عن استخدام سمات النطاق مع الجداول"
  },
  "leave_as_is_4facfe55": {
    "message": "ترك كما هو"
  },
  "left_3ea9d375": {
    "message": "اليسار"
  },
  "left_align_43d95491": {
    "message": "محاذاة إلى اليسار"
  },
  "left_angle_bracket_c87a6d07": {
    "message": "Left Angle Bracket"
  },
  "left_arrow_4fde1a64": {
    "message": "Left Arrow"
  },
  "left_arrow_with_hook_5bfcad93": {
    "message": "Left Arrow With Hook"
  },
  "left_ceiling_ee9dd88a": {
    "message": "Left Ceiling"
  },
  "left_curly_brace_1726fb4": {
    "message": "Left Curly Brace"
  },
  "left_downard_harpoon_arrow_1d7b3d2e": {
    "message": "Left Downard Harpoon Arrow"
  },
  "left_floor_29ac2274": {
    "message": "Left Floor"
  },
  "left_to_right_e9b4fd06": {
    "message": "‏‏من اليسار إلى اليمين"
  },
  "left_upward_harpoon_arrow_3a562a96": {
    "message": "Left Upward Harpoon Arrow"
  },
  "leftward_arrow_1e4765de": {
    "message": "Leftward Arrow"
  },
  "leftward_pointing_triangle_d14532ce": {
    "message": "Leftward Pointing Triangle"
  },
  "less_than_a26c0641": {
    "message": "أقل من"
  },
  "less_than_or_equal_be5216cb": {
    "message": "أقل من أو يساوي"
  },
  "library_icon_ae1e54cf": {
    "message": "أيقونة المكتبة"
  },
  "light_blue_5374f600": {
    "message": "أزرق فاتح"
  },
  "link_7262adec": {
    "message": "ارتباط"
  },
  "link_options_a16b758b": {
    "message": "خيارات الارتباط"
  },
  "link_type_linktypemessage_c6d26815": {
    "message": "نوع الارتباط: { linkTypeMessage }"
  },
  "link_with_text_starting_with_start_b3fcbe71": {
    "message": "رابط بنص يبدأ بـ { start }"
  },
  "links_14b70841": {
    "message": "الارتباطات"
  },
  "links_to_an_external_site_de74145d": {
    "message": "ارتباطات إلى موقع خارجي."
  },
  "lists_cd1336fc": {
    "message": "القوائم"
  },
  "lists_should_be_formatted_as_lists_f862de8d": {
    "message": "يجب تنسيق القوائم في صورة قوائم."
  },
  "load_more_35d33c7": {
    "message": "تحميل المزيد"
  },
  "loading_25990131": {
    "message": "جارٍ التحميل..."
  },
  "loading_bde52856": {
    "message": "جارٍ التحميل"
  },
  "loading_closed_captions_subtitles_failed_95ceef47": {
    "message": "تعذر تحميل التسميات التوضيحية/العناوين الفرعية."
  },
  "loading_external_tool_d839042c": {
    "message": "جارٍ تحميل الأداة الخارجية"
  },
  "loading_failed_b3524381": {
    "message": "فشل التحميل..."
  },
  "loading_failed_e6a9d8ef": {
    "message": "فشل التحميل."
  },
  "loading_folders_d8b5869e": {
    "message": "جارٍ تحميل المجلدات"
  },
  "loading_placeholder_for_filename_792ef5e8": {
    "message": "جارٍ تحميل عنصر النائب لـ { fileName }"
  },
  "loading_please_wait_d276220a": {
    "message": "جارٍ التحميل، يرجى الانتظار"
  },
  "loading_preview_9f077aa1": {
    "message": "جارٍ تحميل المعاينة"
  },
  "lock_speed_at_1x_57d4f815": {
    "message": "تأمين السرعة عند 1x"
  },
  "locked_762f138b": {
    "message": "مؤمّن"
  },
  "logical_equivalence_76fca396": {
    "message": "تكافؤ منطقي"
  },
  "logical_equivalence_short_8efd7b4f": {
    "message": "تكافؤ منطقي (قصير)"
  },
  "logical_equivalence_short_and_thick_1e1f654d": {
    "message": "تكافؤ منطقي (قصير وسميك)"
  },
  "logical_equivalence_thick_662dd3f2": {
    "message": "تكافؤ منطقي (سميك)"
  },
  "low_horizontal_dots_cc08498e": {
    "message": "نقاط أفقية منخفضة"
  },
  "magenta_4a65993c": {
    "message": "ماجنتا"
  },
  "maps_to_e5ef7382": {
    "message": "Maps To"
  },
  "math_icon_ad4e9d03": {
    "message": "أيقونة الرياضيات"
  },
  "media_af190855": {
    "message": "الوسائط"
  },
  "media_file_is_processing_please_try_again_later_58a6d49": {
    "message": "جارٍ معالجة ملف الوسائط. الرجاء إعادة المحاولة لاحقًا."
  },
  "media_options_saved_560c4ec8": {
    "message": "تم حفظ خيارات الوسائط."
  },
  "media_title_2112243b": {
    "message": "عنوان الوسائط"
  },
  "medium_5a8e9ead": {
    "message": "متوسط"
  },
  "medium_width_x_height_px_b076f6b6": {
    "message": "متوسط ({ width } × { height } بكسل)"
  },
  "merge_links_2478df96": {
    "message": "دمج الروابط"
  },
  "mic_a7f3d311": {
    "message": "الميكروفون"
  },
  "microphone_disabled_15c83130": {
    "message": "تم تعطيل الميكروفون"
  },
  "middle_27dc1d5": {
    "message": "الأوسط"
  },
  "minimize_file_preview_da911944": {
    "message": "تصغير معاينة الملف"
  },
  "minimize_video_20aa554b": {
    "message": "تصغير الفيديو"
  },
  "minus_fd961e2e": {
    "message": "سالب"
  },
  "minus_plus_3461f637": {
    "message": "سالب/موجب"
  },
  "misc_3b692ea7": {
    "message": "متنوع"
  },
  "miscellaneous_e9818229": {
    "message": "متنوعات"
  },
  "module_90d9fd32": {
    "message": "الوحدة"
  },
  "modules_c4325335": {
    "message": "الوحدات النمطية"
  },
  "moving_image_to_crop_directionword_6f66cde2": {
    "message": "جارٍ نقل الصورة إلى القص { directionWord }"
  },
  "mu_37223b8b": {
    "message": "Mu"
  },
  "multi_color_image_63d7372f": {
    "message": "صورة متعددة الألوان"
  },
  "multiplication_sign_15f95c22": {
    "message": "علامة الضرب"
  },
  "music_icon_4db5c972": {
    "message": "أيقونة الموسيقى"
  },
  "my_files_2f621040": {
    "message": "ملفاتي"
  },
  "n_th_root_9991a6e4": {
    "message": "N-th Root"
  },
  "nabla_1e216d25": {
    "message": "Nabla"
  },
  "name_1aed4a1b": {
    "message": "الاسم"
  },
  "name_color_ceec76ff": {
    "message": "{ name } ({ color })"
  },
  "natural_music_54a70258": {
    "message": "Natural (موسيقى)"
  },
  "natural_numbers_3da07060": {
    "message": "الأرقام الطبيعية"
  },
  "navigate_through_the_menu_or_toolbar_415a4e50": {
    "message": "تنقل من خلال القائمة أو شريط الأدوات"
  },
  "navigation_ee9af92d": {
    "message": "التنقل"
  },
  "nested_greater_than_d852e60d": {
    "message": "Nested Greater Than"
  },
  "nested_less_than_27d17e58": {
    "message": "Nested Less Than"
  },
  "new_quiz_34aacba6": {
    "message": "اختبار جديد"
  },
  "next_40e12421": {
    "message": "التالي"
  },
  "next_findtext_9d69f0fe": {
    "message": "{ findText } التالي"
  },
  "no_accessibility_issues_were_detected_f8d3c875": {
    "message": "لم يتم الكشف عن مشاكل إمكانية الوصول."
  },
  "no_announcements_created_yet_c44a94f4": {
    "message": "لم يتم إنشاء أي إعلانات حتى الآن."
  },
  "no_announcements_found_20185afc": {
    "message": "لم يتم العثور على إعلانات."
  },
  "no_assignments_created_yet_1b236d87": {
    "message": "لم يتم إنشاء مهام حتى الآن."
  },
  "no_assignments_found_79e46d7f": {
    "message": "لم يتم العثور على مهام."
  },
  "no_changes_to_save_d29f6e91": {
    "message": "لا توجد تغييرات للحفظ."
  },
  "no_discussions_created_yet_ff99abe3": {
    "message": "لم يتم إنشاء نقاشات حتى الآن."
  },
  "no_discussions_found_9284063b": {
    "message": "لم يتم العثور على نقاشات."
  },
  "no_e16d9132": {
    "message": "لا"
  },
  "no_file_chosen_9a880793": {
    "message": "لم يتم اختيار ملف"
  },
  "no_headers_9bc7dc7f": {
    "message": "بلا رؤوس"
  },
  "no_modules_created_yet_c71b6d4d": {
    "message": "لم يتم إنشاء وحدات حتى الآن."
  },
  "no_modules_found_2df43a40": {
    "message": "لم يتم العثور على وحدات."
  },
  "no_pages_created_yet_c379fa6e": {
    "message": "لم يتم إنشاء صفحات حتى الآن."
  },
  "no_pages_found_6799350": {
    "message": "لم يتم العثور على صفحات."
  },
  "no_preview_is_available_for_this_file_f940114a": {
    "message": "لا توجد معاينة متوفرة لهذا الملف."
  },
  "no_quizzes_created_yet_1a2370b9": {
    "message": "لم يتم إنشاء اختبارات موجزة حتى الآن."
  },
  "no_quizzes_found_c80c537a": {
    "message": "لم يتم العثور على اختبارات موجزة."
  },
  "no_results_940393cf": {
    "message": "لا توجد نتائج."
  },
  "no_results_found_58717065": {
    "message": "لم يتم العثور على نتائج"
  },
  "no_results_found_for_filterterm_ad1b04c8": {
    "message": "لم يتم العثور على نتائج لـ { filterTerm }"
  },
  "no_video_1ed00b26": {
    "message": "لا يوجد مقطع فيديو"
  },
  "none_3b5e34d2": {
    "message": "بلا"
  },
  "none_selected_b93d56d2": {
    "message": "لم يتم تحديد شيء"
  },
  "normal_text_7b03da48": {
    "message": "نص عادي"
  },
  "not_equal_6e2980e6": {
    "message": "لا يساوي"
  },
  "not_in_not_an_element_of_fb1ffb54": {
    "message": "Not In (Not An Element Of)"
  },
  "not_negation_1418ebb8": {
    "message": "Not (نفي)"
  },
  "not_subset_dc2b5e84": {
    "message": "Not Subset"
  },
  "not_subset_strict_23d282bf": {
    "message": "Not Subset (Strict)"
  },
  "not_superset_5556b913": {
    "message": "Not Superset"
  },
  "not_superset_strict_24e06f36": {
    "message": "Not Superset (Strict)"
  },
  "nu_1c0f6848": {
    "message": "Nu"
  },
  "octagon_e48be9f": {
    "message": "ثماني"
  },
  "olive_6a3e4d6b": {
    "message": "زيتي"
  },
  "omega_8f2c3463": {
    "message": "Omega"
  },
  "one_of_the_following_styles_must_be_added_to_save__1de769aa": {
    "message": "يجب إضافة أحد الأنماط التالية لحفظ الأيقونة: لون الأيقونة، حجم الإطار، نص الأيقونة، الصورة"
  },
  "one_or_more_files_failed_to_paste_please_try_uploa_7fa39dd3": {
    "message": "تعذر لصق ملف واحد أو أكثر يرجى تحميل الملفات أو سحبها وإفلاتها."
  },
  "open_circle_e9bd069": {
    "message": "دائرة مفتوحة"
  },
  "open_this_keyboard_shortcuts_dialog_9658b83a": {
    "message": "افتح مربع حوار اختصارات لوحة المفاتيح هذا"
  },
  "open_title_application_fd624fc5": {
    "message": "فتح تطبيق { title }"
  },
  "operators_a2ef9a93": {
    "message": "المشغلون"
  },
  "options_3ab0ea65": {
    "message": "الخيارات"
  },
  "or_9b70ccaa": {
    "message": "أو"
  },
  "orange_81386a62": {
    "message": "برتقالي"
  },
  "ordered_and_unordered_lists_cfadfc38": {
    "message": "القوائم المرتبة وغير المرتبة"
  },
  "other_editor_shortcuts_may_be_found_at_404aba4a": {
    "message": "يمكن العثور على اختصارات أخرى للمحرر على"
  },
  "outline_color_3ef2cea7": {
    "message": "لون المخطط التفصيلي"
  },
  "outline_size_a6059a21": {
    "message": "حجم المخطط التفصيلي"
  },
  "p_is_not_a_valid_protocol_b1c4efaa": {
    "message": "{ p } ليس بروتوكولاً صالحًا."
  },
  "page_50c4823d": {
    "message": "صفحة"
  },
  "pages_e5414c2c": {
    "message": "الصفحات"
  },
  "paragraph_5e5ad8eb": {
    "message": "الفقرة"
  },
  "paragraph_applied_959b3fe5": {
    "message": "تم تطبيق الفقرة"
  },
  "paragraph_removed_d09320e": {
    "message": "تمت إزالة الفقرة"
  },
  "paragraph_starting_with_start_a59923f8": {
    "message": "فقرة تبدأ بـ { start }"
  },
  "parallel_d55d6e38": {
    "message": "موازي"
  },
  "partial_derivative_4a9159df": {
    "message": "جزئي (مشتق)"
  },
  "pass_1c19a2b3": {
    "message": "نجاح"
  },
  "paste_5963d1c1": {
    "message": "لصق"
  },
  "pause_12af3bb4": {
    "message": "إيقاف مؤقت"
  },
  "pentagon_17d82ea3": {
    "message": "خماسي"
  },
  "people_b4ebb13c": {
    "message": "أشخاص"
  },
  "percentage_34ab7c2c": {
    "message": "نسبة مئوية"
  },
  "percentage_must_be_a_number_8033c341": {
    "message": "يجب أن تكون النسبة المئوية رقمًا"
  },
  "percentage_must_be_at_least_percentage_a98ca8fc": {
    "message": "يجب أن تكون النسبة المئوية { percentage }% بحد أدنى"
  },
  "performing_arts_icon_f3497486": {
    "message": "أيقونة الفنون التعبيرية"
  },
  "perpendicular_7c48ede4": {
    "message": "عمودي"
  },
  "phi_4ac33b6d": {
    "message": "Phi"
  },
  "phi_variant_c9bb3ac5": {
    "message": "Phi (متغير)"
  },
  "physical_education_icon_d7dffd3e": {
    "message": "أيقونة التربية البدنية"
  },
  "pi_dc4f0bd8": {
    "message": "Pi"
  },
  "pi_variant_10f5f520": {
    "message": "Pi (متغير)"
  },
  "pick_a_color_557abfb0": {
    "message": "اختر لونًا"
  },
  "pink_68ad45cb": {
    "message": "وردي"
  },
  "pixels_52ece7d1": {
    "message": "بكسل"
  },
  "pixels_must_be_at_least_width_x_height_px_e965edd5": {
    "message": "يجب أن تكون البكسلات { width } x { height } بكسل بحد أدنى"
  },
  "play_1a47eaa7": {
    "message": "تشغيل"
  },
  "play_media_comment_35257210": {
    "message": "تشغيل تعليق الوسائط."
  },
  "play_media_comment_by_name_from_createdat_c230123d": {
    "message": "تشغيل تعليق الوسائط بواسطة { name } من { createdAt }."
  },
  "player_layout_14e09a29": {
    "message": "تصميم المُشغل"
  },
  "please_allow_canvas_to_access_your_microphone_and__dc2c3079": {
    "message": "يرجى السماح لـ Canvas بالوصول إلى الميكروفون وكاميرا الويب لديك."
  },
  "please_choose_a_file_c2449cc": {
    "message": "يرجى اختيار ملف"
  },
  "please_enter_a_file_name_f159edc1": {
    "message": "يرجى إدخال اسم الملف"
  },
  "please_enter_a_valid_video_url_from_a_supported_pl_30dc0596": {
    "message": "يُرجى إدخال عنوان URL صالح للفيديو من منصة مدعومة."
  },
  "please_select_a_file_of_a_supported_type_1fc578f2": {
    "message": "يرجى تحديد ملف بنوع مدعوم"
  },
  "plus_d43cd4ec": {
    "message": "موجب"
  },
  "plus_minus_f8be2e83": {
    "message": "موجب/سالب"
  },
  "posted_when_a578f5ab": {
    "message": "المنشور: { when }"
  },
  "power_set_4f26f316": {
    "message": "مجموعة المجموعات الجزئية"
  },
  "precedes_196b9aef": {
    "message": "Precedes"
  },
  "precedes_equal_20701e84": {
    "message": "Precedes Equal"
  },
  "preformatted_d0670862": {
    "message": "منسق مسبقًا"
  },
  "prepend_findtext_append_8e0e769a": {
    "message": "{ prepend }{ findText }{ append }"
  },
  "prev_f82cbc48": {
    "message": "السابق"
  },
  "preview_53003fd2": {
    "message": "معاينة"
  },
  "preview_a3f8f854": {
    "message": "معاينة"
  },
  "preview_in_overlay_ed772c46": {
    "message": "المعاينة بشكل متراكب"
  },
  "preview_inline_9787330": {
    "message": "معاينة مضمّنة"
  },
  "previous_bd2ac015": {
    "message": "السابق"
  },
  "previous_findtext_8dfbfd30": {
    "message": "{ findText } السابق"
  },
  "previously_chosen_colors_f1338315": {
    "message": "الألوان المختار سابقًا"
  },
  "prime_917ea60e": {
    "message": "Prime"
  },
  "prime_numbers_13464f61": {
    "message": "Prime Numbers"
  },
  "product_39cf144f": {
    "message": "منتج"
  },
  "proportional_f02800cc": {
    "message": "تناسبي"
  },
  "protocol_must_be_ftp_http_https_mailto_skype_tel_o_73beb4f8": {
    "message": "يجب أن يكون البروتوكول ftp وhttp وhttps وmailto وskype وإلا سيتم حذفه"
  },
  "psi_e3f5f0f7": {
    "message": "Psi"
  },
  "published_c944a23d": {
    "message": "تم النشر"
  },
  "published_when_302d8e23": {
    "message": "تاريخ النشر: { when }"
  },
  "pumpkin_904428d5": {
    "message": "يقطين"
  },
  "purple_7678a9fc": {
    "message": "أرجواني"
  },
  "quaternions_877024e0": {
    "message": "الرباعيات"
  },
  "quiz_e0dcce8f": {
    "message": "الاختبار الموجز"
  },
  "quizzes_7e598f57": {
    "message": "الاختبارات الموجزة"
  },
  "rational_numbers_80ddaa4a": {
    "message": "أعداد جذرية"
  },
  "real_numbers_7c99df94": {
    "message": "أعداد حقيقية"
  },
  "real_portion_of_complex_number_7dad33b5": {
    "message": "الجزء الحقيقي (من العدد المركب)"
  },
  "record_7c9448b": {
    "message": "تسجيل"
  },
  "record_upload_media_5fdce166": {
    "message": "تسجيل/تحميل الوسائط"
  },
  "recording_98da6bda": {
    "message": "جارٍ التسجيل"
  },
  "red_8258edf3": {
    "message": "أحمر"
  },
  "relationships_6602af70": {
    "message": "العلاقات"
  },
  "religion_icon_246e0be1": {
    "message": "أيقونة الدين"
  },
  "remove_f47dc62a": {
    "message": "إزالة"
  },
  "remove_filename_3ea029f6": {
    "message": "إزالة { filename }"
  },
  "remove_heading_style_5fdc8855": {
    "message": "إزالة نمط العنوان"
  },
  "remove_link_d1f2f4d0": {
    "message": "إزالة الارتباط"
  },
  "replace_all_d3d68b3": {
    "message": "استبدال الكل"
  },
  "replace_all_findtext_with_replacetext_da574b32": {
    "message": "استبدال كل { findText } بـ{ replaceText }"
  },
  "replace_e61834a7": {
    "message": "استبدال"
  },
  "replace_findtext_with_replacetext_7b5c7fb3": {
    "message": "استبدال { findText } بـ{ replaceText }"
  },
  "replace_with_eeff01ad": {
    "message": "استبدال بـ"
  },
  "replaced_alertfindtext_with_alertreplacetext_de5c1795": {
    "message": "تم استبدال { alertFindText } بـ{ alertReplaceText }"
  },
  "replaced_all_alertfindtext_with_alertreplacetext_83fdfe59": {
    "message": "تم استبدال كل { alertFindText } بـ{ alertReplaceText }"
  },
  "reset_95a81614": {
    "message": "إعادة التعيين"
  },
  "resize_ec83d538": {
    "message": "تغيير الحجم"
  },
  "restore_auto_save_deccd84b": {
    "message": "استعادة الحفظ التلقائي؟"
  },
  "result_index_of_max_7db5ad8b": {
    "message": "نتيجة { index } من { max }."
  },
  "reverse_turnstile_does_not_yield_7558be06": {
    "message": "Reverse Turnstile (Does Not Yield)"
  },
  "rho_a0244a36": {
    "message": "Rho"
  },
  "rho_variant_415245cd": {
    "message": "Rho (متغير)"
  },
  "rich_content_editor_2708ef21": {
    "message": "محرر محتوى"
  },
  "rich_text_area_press_oskey_f8_for_rich_content_edi_c2f651d": {
    "message": "مساحة النص المنسق اضغط على { OSKey }+F8 لاختصارات محرر المحتوى المنسق."
  },
  "right_71ffdc4d": {
    "message": "لليمين"
  },
  "right_align_39e7a32a": {
    "message": "محاذاة إلى اليمين"
  },
  "right_angle_bracket_d704e2d6": {
    "message": "Right Angle Bracket"
  },
  "right_arrow_35e0eddf": {
    "message": "Right Arrow"
  },
  "right_arrow_with_hook_29d92d31": {
    "message": "Right Arrow With Hook"
  },
  "right_ceiling_839dc744": {
    "message": "Right Ceiling"
  },
  "right_curly_brace_5159d5cd": {
    "message": "Right Curly Brace"
  },
  "right_downward_harpoon_arrow_d71b114f": {
    "message": "Right Downward Harpoon Arrow"
  },
  "right_floor_5392d5cf": {
    "message": "Right Floor"
  },
  "right_to_left_9cfb092a": {
    "message": "من اليمين إلى اليسار"
  },
  "right_upward_harpoon_arrow_f5a34c73": {
    "message": "Right Upward Harpoon Arrow"
  },
  "rightward_arrow_32932107": {
    "message": "Rightward Arrow"
  },
  "rightward_pointing_triangle_60330f5c": {
    "message": "مثلث يشير لليمين"
  },
  "rotate_image_90_degrees_2ab77c05": {
    "message": "تدوير الصورة زاوية -90"
  },
  "rotate_image_90_degrees_6c92cd42": {
    "message": "تدوير الصورة زاوية 90"
  },
  "rotation_9699c538": {
    "message": "تدوير"
  },
  "row_fc0944a7": {
    "message": "صف"
  },
  "row_group_979f5528": {
    "message": "مجموعة الصف"
  },
  "sadly_the_pretty_html_editor_is_not_keyboard_acces_50da7665": {
    "message": "للأسف، محرر HTML الأنيق لا يمكن الوصول إليه من خلال لوحة المفاتيح. قم بالوصول إلى محرر HTML الأنيق من هنا."
  },
  "save_11a80ec3": {
    "message": "حفظ"
  },
  "save_copy_ca63944e": {
    "message": "حفظ النسخ"
  },
  "save_media_cb9e786e": {
    "message": "حفظ الوسائط"
  },
  "saved_icon_maker_icons_df86e2a1": {
    "message": "تم حفظ أيقونة صانع الأيقونات"
  },
  "screen_readers_cannot_determine_what_is_displayed__6a5842ab": {
    "message": "لا يمكن لقارئات الشاشة تحديد المعروض في صورة بدون نص بديل وفي الغالب تكون أسماء الملفات سلسلة بلا معنى من الأرقام والأحرف التي لا تصف السياق أو المعنى."
  },
  "screen_readers_cannot_determine_what_is_displayed__6f1ea667": {
    "message": "لا يمكن لقارئات الشاشة تحديد المعروض في صورة بدون نص بديل يصف محتوى الصورة ومعناها. يجب أن يكون النص البديل بسيطًا وموجزًا."
  },
  "screen_readers_cannot_determine_what_is_displayed__a57e6723": {
    "message": "لا يمكن لقارئات الشاشة تحديد المعروض في صورة بدون نص بديل يصف محتوى الصورة ومعناها."
  },
  "screen_readers_cannot_interpret_tables_without_the_bd861652": {
    "message": "لا يمكن لقارئات الشاشة تفسير الجداول بدون بنية ملائمة. تزود رؤوس الجدول إرشادات ونطاقًا للمحتوى."
  },
  "screen_readers_cannot_interpret_tables_without_the_e62912d5": {
    "message": "لا يمكن لقارئات الشاشة تفسير الجداول بدون بنية ملائمة. تصف التسميات التوضيحية للجدول السياق والفهم العام للجدول."
  },
  "screen_readers_cannot_interpret_tables_without_the_f0bdec0f": {
    "message": "لا يمكن لقارئات الشاشة تفسير الجداول بدون بنية ملائمة. تزود رؤوس الجدول إرشادات ونظرة عامة على المحتوى."
  },
  "script_l_42a7b254": {
    "message": "Script L"
  },
  "search_280d00bd": {
    "message": "بحث"
  },
  "select_audio_source_21043cd5": {
    "message": "حدد مصدر الصوت"
  },
  "select_crop_shape_d441feeb": {
    "message": "حدد قص شكل"
  },
  "select_language_7c93a900": {
    "message": "اختر اللغة"
  },
  "select_video_source_1b5c9dbe": {
    "message": "حدد مصدر الفيديو"
  },
  "selected_274ce24f": {
    "message": "تم التحديد"
  },
  "selected_linkfilename_c093b1f2": {
    "message": "{ linkFileName } المحدد"
  },
  "selection_b52c4c5e": {
    "message": "تحديد"
  },
  "set_header_scope_8c548f40": {
    "message": "تعيين نطاق الرأس"
  },
  "set_minus_b46e9b88": {
    "message": "Set Minus"
  },
  "set_table_header_cfab13a0": {
    "message": "تعيين رأس الجدول"
  },
  "sharp_music_ab956814": {
    "message": "Sharp (موسيقي)"
  },
  "shift_arrows_4d5785fe": {
    "message": "SHIFT+أسهم"
  },
  "shift_o_to_open_the_pretty_html_editor_55ff5a31": {
    "message": "اضغط على Shift-O لفتح محرر HTML الأنيق."
  },
  "shortcut_911d6255": {
    "message": "اختصار"
  },
  "show_image_options_1e2ecc6b": {
    "message": "إظهار خيارات الصورة"
  },
  "show_link_options_545338fd": {
    "message": "إظهار خيارات الارتباطات"
  },
  "show_rolling_transcript_c1481744": {
    "message": "إظهار إصدار النسخة النصية"
  },
  "show_rolling_transcript_d353aca4": {
    "message": "إظهار إصدار نسخة نصية"
  },
  "sighted_users_browse_web_pages_quickly_looking_for_1d4db0c1": {
    "message": "يتصفح المستخدمون الذين يتمتعون بالقدرة على الإبصار صفحات الويب بشكل سريع، بحثًا عن عناوين كبيرة أو بخط عريض. ويعتمد مستخدمو قارئة الشاشة على الرؤوس لفهم السياق. يجب أن توظف الرؤوس البنية الملائمة."
  },
  "sighted_users_browse_web_pages_quickly_looking_for_ade806f5": {
    "message": "يتصفح المستخدمون الذين يتمتعون بالقدرة على الإبصار صفحات الويب بشكل سريع، بحثًا عن عناوين كبيرة أو بخط عريض. ويعتمد مستخدمو قارئة الشاشة على الرؤوس لفهم السياق. يجب أن تكون الرؤوس موجزة في نطاق البنية الملائمة."
  },
  "sigma_5c35e553": {
    "message": "Sigma"
  },
  "sigma_variant_8155625": {
    "message": "Sigma (متغير)"
  },
  "single_color_image_4e5d4dbc": {
    "message": "صورة بلون واحد"
  },
  "single_color_image_color_95fa9a87": {
    "message": "لون صورة بلون واحد"
  },
  "size_b30e1077": {
    "message": "الحجم"
  },
  "size_of_caption_file_is_greater_than_the_maximum_m_bff5f86e": {
    "message": "حجم ملف التسمية التوضيحية يتجاوز الحد الأقصى المسموح به من { max } كيلوبايت."
  },
  "small_b070434a": {
    "message": "صغير"
  },
  "small_width_x_height_px_359acd38": {
    "message": "صغير ({ width } × { height } بكسل)"
  },
  "solid_circle_9f061dfc": {
    "message": "Solid Circle"
  },
  "something_went_wrong_89195131": {
    "message": "حدث خطأ ما."
  },
  "something_went_wrong_accessing_your_webcam_6643b87e": {
    "message": "حدث خطأ ما أثناء الوصول إلى كاميرا الويب الخاصة بك."
  },
  "something_went_wrong_and_i_don_t_know_what_to_show_e0c54ec8": {
    "message": "حدثت مشكلة ولا أعلم ماذا أعرض لك."
  },
  "something_went_wrong_check_your_connection_reload__c7868286": {
    "message": "حدث خطأ ما. تحقق من الاتصال وأعد تحميل الصفحة وأعد المحاولة."
  },
  "something_went_wrong_d238c551": {
    "message": "حدث خطأ ما"
  },
  "something_went_wrong_while_sharing_your_screen_8de579e5": {
    "message": "حدث خطأ ما أثناء مشاركة شاشتك."
  },
  "sort_by_e75f9e3e": {
    "message": "الفزر حسب"
  },
  "spades_suit_b37020c2": {
    "message": "Spades (Suit)"
  },
  "square_511eb3b3": {
    "message": "مربع"
  },
  "square_cap_9ec88646": {
    "message": "Square Cap"
  },
  "square_cup_b0665113": {
    "message": "Square Cup"
  },
  "square_root_e8bcbc60": {
    "message": "Square Root"
  },
  "square_root_symbol_d0898a53": {
    "message": "Square Root Symbol"
  },
  "square_subset_17be67cb": {
    "message": "Square Subset"
  },
  "square_subset_strict_7044e84f": {
    "message": "Square Subset (Strict)"
  },
  "square_superset_3be8dae1": {
    "message": "Square Superset"
  },
  "square_superset_strict_fa4262e4": {
    "message": "Square Superset (Strict)"
  },
  "square_unordered_list_b15ce93b": {
    "message": "قائمة مربعة غير مرتبة"
  },
  "star_8d156e09": {
    "message": "نجمة"
  },
  "start_over_f7552aa9": {
    "message": "البدء مرة أخرى"
  },
  "start_recording_9a65141a": {
    "message": "بدء التسجيل"
  },
  "steel_blue_14296f08": {
    "message": "أزرق فولاذي"
  },
  "studio_media_options_ee504361": {
    "message": "خيارات وسائط Studio"
  },
  "studio_media_options_tray_cfb94654": {
    "message": "علبة خيارات وسائط Studio"
  },
  "styles_2aa721ef": {
    "message": "الأنماط"
  },
  "submit_a3cc6859": {
    "message": "إرسال"
  },
  "submitting_b90fac62": {
    "message": "جارٍ الإرسال..."
  },
  "subscript_59744f96": {
    "message": "منخفض"
  },
  "subset_19c1a92f": {
    "message": "Subset"
  },
  "subset_strict_8d8948d6": {
    "message": "Subset (Strict)"
  },
  "succeeds_9cc31be9": {
    "message": "Succeeds"
  },
  "succeeds_equal_158e8c3a": {
    "message": "Succeeds Equal"
  },
  "sum_b0842d31": {
    "message": "Sum"
  },
  "superscript_8cb349a2": {
    "message": "مرتفع"
  },
  "superscript_and_subscript_37f94a50": {
    "message": "مرتفع ومنخفض"
  },
  "superset_c4db8a7a": {
    "message": "Superset"
  },
  "superset_strict_c77dd6d2": {
    "message": "Superset (Strict)"
  },
  "supported_file_types_srt_or_webvtt_7d827ed": {
    "message": "أنواع الملفات المدعومة: SRT أو WebVTT"
  },
  "switch_to_pretty_html_editor_a3cee15f": {
    "message": "التبديل إلي محرر HTML المنسق"
  },
  "switch_to_raw_html_editor_f970ae1a": {
    "message": "التبديل إلي محرر HTML البسيط"
  },
  "switch_to_the_html_editor_146dfffd": {
    "message": "التبديل إلي محرر html"
  },
  "switch_to_the_rich_text_editor_63c1ecf6": {
    "message": "التبديل إلى محرر النص المنسق"
  },
  "syllabus_f191f65b": {
    "message": "المناهج"
  },
  "system_audio_allowed_b2508f8c": {
    "message": "تم السماح لصوت النظام"
  },
  "system_audio_disabled_c177bd13": {
    "message": "تم تمكين صوت النظام"
  },
  "tab_arrows_4cf5abfc": {
    "message": "ضغط/أسهم"
  },
  "table_header_starting_with_start_ffcabba6": {
    "message": "يبدأ رأس الجدول بـ { start }"
  },
  "table_starting_with_start_e7232848": {
    "message": "يبدأ الجدول بـ { start }"
  },
  "tables_headers_should_specify_scope_5abf3a8e": {
    "message": "يجب أن تحدد رؤوس الجداول نطاقًا."
  },
  "tables_should_include_a_caption_describing_the_con_e91e78fc": {
    "message": "يجب أن تتضمن الجداول تسمية توضيحية تصف محتويات الجدول."
  },
  "tables_should_include_at_least_one_header_48779eac": {
    "message": "يجب أن تتضمن الجداول رأسًا واحدًا على الأقل."
  },
  "tau_880974b7": {
    "message": "Tau"
  },
  "teal_f729a294": {
    "message": "أزرق مخضر"
  },
  "text_7f4593da": {
    "message": "نص"
  },
  "text_background_color_16e61c3f": {
    "message": "لون خلفية النص"
  },
  "text_color_acf75eb6": {
    "message": "لون النص"
  },
  "text_is_difficult_to_read_without_sufficient_contr_69e62bd6": {
    "message": "تصعب قراءة النص بدون درجة تباين كافية بين النص والخلفية، خاصةً لمن يعانون من ضعف الرؤية."
  },
  "text_larger_than_18pt_or_bold_14pt_should_display__5c364db6": {
    "message": "يجب أن يعرض النص الأكبر من 18 نقطة (أو 14 نقطة بخط عريض) معدل تباين لا يقل عن 3:1."
  },
  "text_optional_384f94f7": {
    "message": "النص (اختياري)"
  },
  "text_position_8df8c162": {
    "message": "موضع النص"
  },
  "text_size_887c2f6": {
    "message": "حجم النص"
  },
  "text_smaller_than_18pt_or_bold_14pt_should_display_aaffb22b": {
    "message": "يجب أن يعرض النص الأصغر من 18 نقطة (أو 14 نقطة بخط عريض) معدل تباين لا يقل عن 4.5:1."
  },
  "the_document_preview_is_currently_being_processed__7d9ea135": {
    "message": "تجري معالجة معاينة المستند حاليًا. الرجاء إعادة المحاولة لاحقًا."
  },
  "the_first_heading_on_a_page_should_be_an_h2_859089f2": {
    "message": "يجب أن يكون أول عنوان في الصفحة هو H2."
  },
  "the_height_of_rich_content_area_is_decreased_36920e0": {
    "message": "قل ارتفاع منطقة محتوى النص المنسق."
  },
  "the_height_of_rich_content_area_is_increased_74c2358d": {
    "message": "زاد ارتفاع منطقة محتوى النص المنسق."
  },
  "the_material_is_in_the_public_domain_279c39a3": {
    "message": "توجد المادة في المجال العام"
  },
  "the_material_is_licensed_under_creative_commons_3242cb5e": {
    "message": "المادة مرخصة بموجب المشاع الإبداعي"
  },
  "the_material_is_subject_to_an_exception_e_g_fair_u_a39c8ca2": {
    "message": "المادة خاضعة لاستثناء - مثال استخدام عادل أو حق الاقتباس أو استثناءات أخرى بموجب قوانين حقوق النشر المعمول بها"
  },
  "the_pretty_html_editor_is_not_keyboard_accessible__d6d5d2b": {
    "message": "محرر HTML الأنيق لا يمكن الوصول إليه من خلال لوحة المفاتيح. اضغط على Shift-O لفتح محرر HTML البسيط."
  },
  "therefore_d860e024": {
    "message": "Therefore"
  },
  "theta_ce2d2350": {
    "message": "Theta"
  },
  "theta_variant_fff6da6f": {
    "message": "Theta (Variant)"
  },
  "thick_downward_arrow_b85add4c": {
    "message": "Thick Downward Arrow"
  },
  "thick_left_arrow_d5f3e925": {
    "message": "Thick Left Arrow"
  },
  "thick_leftward_arrow_6ab89880": {
    "message": "Thick Leftward Arrow"
  },
  "thick_right_arrow_3ed5e8f7": {
    "message": "Thick Right Arrow"
  },
  "thick_rightward_arrow_a2e1839e": {
    "message": "Thick Rightward Arrow"
  },
  "thick_upward_arrow_acd20328": {
    "message": "Thick Upward Arrow"
  },
  "this_document_cannot_be_displayed_within_canvas_7aba77be": {
    "message": "لا يمكن عرض هذا المستند في Canvas."
  },
  "this_equation_cannot_be_rendered_in_basic_view_9b6c07ae": {
    "message": "لا يمكن عرض هذه المعادلة في العرض الأساسي."
  },
  "this_image_is_currently_unavailable_25c68857": {
    "message": "هذه الصورة غير متوفرة حاليًا"
  },
  "this_video_may_display_youtube_ads_4d19d590": {
    "message": "قد يعرض هذا الفيديو إعلانات YouTube."
  },
  "though_your_video_will_have_the_correct_title_in_t_90e427f3": {
    "message": "بالرغم من أن مقطع الفيديو الخاص بك سيشتمل على العنوان الصحيح في المستعرض، لم نتمكن من تحديثه في قاعدة البيانات."
  },
  "thumbnail_e0de666f": {
    "message": "صورة مصغرة"
  },
  "timebar_a4d18443": {
    "message": "Timebar"
  },
  "title_can_t_be_blank_eb4021d7": {
    "message": "لا يمكن ترك العنوان فارغًا"
  },
  "title_ee03d132": {
    "message": "العنوان"
  },
  "to_be_posted_when_d24bf7dc": {
    "message": "المقرر نشره: { when }"
  },
  "to_do_when_2783d78f": {
    "message": "قائمة مهام: { when }"
  },
  "toggle_summary_group_413df9ac": {
    "message": "تبديل مجموعة { summary }"
  },
  "toggle_tooltip_d3b7cb86": {
    "message": "تبديل تلميح الأداة"
  },
  "tools_2fcf772e": {
    "message": "الأدوات"
  },
  "top_66e0adb6": {
    "message": "Top"
  },
  "transcript_panel_is_available_at_widths_above_720p_1cf94c0d": {
    "message": "تتوفر لوحة النسخة النصية بعرض أكبر من 720 بكسل."
  },
  "tray_839df38a": {
    "message": "العلبة"
  },
  "triangle_6072304e": {
    "message": "مثلث"
  },
  "turnstile_yields_f9e76df1": {
    "message": "Turnstile (Yields)"
  },
  "type_control_f9_to_access_image_options_text_a47e319f": {
    "message": "اضغط على Control F9 للوصول إلى اختيارات الصورة. { text }"
  },
  "type_control_f9_to_access_link_options_text_4ead9682": {
    "message": "اضغط على Control F9 للوصول إلى اختيارات الرابط. { text }"
  },
  "type_control_f9_to_access_table_options_text_92141329": {
    "message": "اضغط Control F9 للوصول إلى اختيارات الجدول. { text }"
  },
  "unable_to_determine_resource_selection_url_7867e060": {
    "message": "يتعذر تحديد عنوان URL تحديد الموارد"
  },
  "underline_applied_ae01ec97": {
    "message": "تم تطبيق التسطير"
  },
  "underline_removed_3693e17c": {
    "message": "تمت إزالة التسطير"
  },
  "union_e6b57a53": {
    "message": "Union"
  },
  "unpublished_dfd8801": {
    "message": "غير منشور"
  },
  "unsaved_changes_will_be_lost_f977252a": {
    "message": "سيتم فقد التغييرات غير المحفوظة."
  },
  "untitled_16aa4f2b": {
    "message": "بدون عنوان"
  },
  "untitled_efdc2d7d": {
    "message": "بدون عنوان"
  },
  "up_and_left_diagonal_arrow_e4a74a23": {
    "message": "Up And Left Diagonal Arrow"
  },
  "up_and_right_diagonal_arrow_935b902e": {
    "message": "Up And Right Diagonal Arrow"
  },
  "up_c553575d": {
    "message": "لأعلى"
  },
  "updated_link_a827e441": {
    "message": "الارتباط المحدث"
  },
  "upload_document_253f0478": {
    "message": "تحميل المستند"
  },
  "upload_file_fd2361b8": {
    "message": "تحميل ملف"
  },
  "upload_image_6120b609": {
    "message": "تحميل صورة"
  },
  "upload_media_ce31135a": {
    "message": "تحميل الوسائط"
  },
  "upload_record_media_e4207d72": {
    "message": "تحميل/تسجيل الوسائط"
  },
  "uploading_19e8a4e7": {
    "message": "جارٍ التحميل"
  },
  "uppercase_alphabetic_ordered_list_3f5aa6b2": {
    "message": "قائمة أبجدية مرتبة بأحرف كبيرة"
  },
  "uppercase_delta_d4f4bc41": {
    "message": "Uppercase Delta"
  },
  "uppercase_gamma_86f492e9": {
    "message": "Uppercase Gamma"
  },
  "uppercase_lambda_c78d8ed4": {
    "message": "Uppercase Lambda"
  },
  "uppercase_omega_8aedfa2": {
    "message": "Uppercase Omega"
  },
  "uppercase_phi_caa36724": {
    "message": "Uppercase Phi"
  },
  "uppercase_pi_fcc70f5e": {
    "message": "Uppercase Pi"
  },
  "uppercase_psi_6395acbe": {
    "message": "Uppercase Psi"
  },
  "uppercase_roman_numeral_ordered_list_853f292b": {
    "message": "قائمة بأرقام رومانية مرتبة بأحرف كبيرة"
  },
  "uppercase_sigma_dbb70e92": {
    "message": "Uppercase Sigma"
  },
  "uppercase_theta_49afc891": {
    "message": "Uppercase Theta"
  },
  "uppercase_upsilon_8c1e623e": {
    "message": "Uppercase Upsilon"
  },
  "uppercase_xi_341e8556": {
    "message": "Uppercase Xi"
  },
  "upsilon_33651634": {
    "message": "Upsilon"
  },
  "upward_and_downward_pointing_arrow_fa90a918": {
    "message": "Upward And Downward Pointing Arrow"
  },
  "upward_and_downward_pointing_arrow_thick_d420fdef": {
    "message": "Upward And Downward Pointing Arrow (Thick)"
  },
  "upward_arrow_9992cb2d": {
    "message": "Upward Arrow"
  },
  "upward_pointing_triangle_d078d7cb": {
    "message": "مثلث يشير لأعلى"
  },
  "url_22a5f3b8": {
    "message": "URL"
  },
  "usage_right_ff96f3e2": {
    "message": "حق الاستخدام:"
  },
  "usage_rights_required_5fe4dd68": {
    "message": "حقوق الاستخدام (مطلوبة)"
  },
  "use_arrow_keys_to_navigate_options_2021cc50": {
    "message": "استخدم مفاتيح الأسهم للتنقل بين الخيارات."
  },
  "use_arrow_keys_to_select_a_shape_c8eb57ed": {
    "message": "استخدم مفاتيح الأسهم لتحديد شكل."
  },
  "use_arrow_keys_to_select_a_size_699a19f4": {
    "message": "استخدم مفاتيح الأسهم لتحديد حجم."
  },
  "use_arrow_keys_to_select_a_text_position_72f9137c": {
    "message": "استخدم مفاتيح الأسهم لتحديد موضع النص."
  },
  "use_arrow_keys_to_select_a_text_size_65e89336": {
    "message": "استخدم مفاتيح الأسهم لتحديد حجم النص."
  },
  "use_arrow_keys_to_select_an_outline_size_e009d6b0": {
    "message": "استخدم مفاتيح الأسهم لتحديد حجم الإطار."
  },
  "used_by_screen_readers_to_describe_the_content_of__4f14b4e4": {
    "message": "يستخدم بواسطة أدوات قراءة الشاشة لوصف محتوى { TYPE }"
  },
  "used_by_screen_readers_to_describe_the_content_of__b1e76d9e": {
    "message": "يستخدم بواسطة أدوات قراءة الشاشة لوصف محتوى الصور"
  },
  "user_documents_c206e61f": {
    "message": "مستندات المستخدم"
  },
  "user_files_78e21703": {
    "message": "ملفات المستخدمين"
  },
  "user_images_b6490852": {
    "message": "صور المستخدمين"
  },
  "user_media_14fbf656": {
    "message": "وسائط المستخدم"
  },
  "vector_notation_cf6086ab": {
    "message": "الخط المتجه (رمز)"
  },
  "vertical_bar_set_builder_notation_4300495f": {
    "message": "شريط رأسي (Set Builder Notation)"
  },
  "vertical_dots_bfb21f14": {
    "message": "نقاط رأسية"
  },
  "video_options_24ef6e5d": {
    "message": "خيارات الفيديو"
  },
  "video_options_tray_3b9809a5": {
    "message": "علبة خيارات الفيديو"
  },
  "video_player_b371005": {
    "message": "مشغل الفيديو"
  },
  "video_player_for_9e7d373b": {
    "message": "مشغل الفيديو لـ "
  },
  "video_player_for_title_ffd9fbc4": {
    "message": "مشغل الفيديو لـ { title }"
  },
  "video_url_889d3263": {
    "message": "عنوان URL الفيديو"
  },
  "view_all_e13bf0a6": {
    "message": "عرض الكل"
  },
  "view_ba339f93": {
    "message": "عرض"
  },
  "view_description_30446afc": {
    "message": "عرض الوصف"
  },
  "view_keyboard_shortcuts_34d1be0b": {
    "message": "عرض اختصارات لوحة المفاتيح"
  },
  "view_title_description_67940918": {
    "message": "عرض وصف { title }"
  },
  "view_word_and_character_counts_a743dd0c": {
    "message": "عرض عدد الكلمات والأحرف"
  },
  "viewer_restrictions_e14274c9": {
    "message": "قيود العارض"
  },
  "we_couldn_t_detect_a_working_microphone_connected__ceb71c40": {
    "message": "لم نتمكن من اكتشاف ميكروفون يعمل متصل بجهازك."
  },
  "we_couldn_t_detect_a_working_webcam_connected_to_y_6715cc4": {
    "message": "لم نتمكن من اكتشاف كاميرا ويب تعمل متصلة بجهازك."
  },
  "we_couldn_t_detect_a_working_webcam_or_microphone__263b6674": {
    "message": "لم نتمكن من اكتشاف كاميرا ويب أو ميكروفون يعملان متصلان بجهازك."
  },
  "webcam_disabled_30c66986": {
    "message": "تم تعطيل كاميرا الويب"
  },
  "webcam_fe91b20f": {
    "message": "كاميرا الويب"
  },
  "webpages_should_only_have_a_single_h1_which_is_aut_dc99189e": {
    "message": "يجب أن تقتصر صفحات الويب على H1 فردي، والذي يستخدمه عنوان الصفحة تلقائيًا. يجب أن يكون أول عنوان في المحتوى الخاص بك هو H2."
  },
  "when_markup_is_used_that_visually_formats_items_as_f941fc1b": {
    "message": "عند استخدام العلامة التي تنسق العناصر في صورة قوائم ولكنها لا تشير إلى علاقة القوائم، فقد يواجه المستخدمون صعوبة في التنقل بين المعلومات."
  },
  "white_87fa64fd": {
    "message": "أبيض"
  },
  "why_523b3d8c": {
    "message": "السبب"
  },
  "width_492fec76": {
    "message": "العرض"
  },
  "width_and_height_must_be_numbers_110ab2e3": {
    "message": "يجب أن يكون العرض والارتفاع أرقاماً"
  },
  "width_x_height_px_ff3ccb93": {
    "message": "{ width } x { height } بكسل"
  },
  "wiki_home_9cd54d0": {
    "message": "الصفحة الرئيسية لـ Wiki"
  },
  "word_count_c77fe3a6": {
    "message": "عدد الكلمات"
  },
  "words_b448b7d5": {
    "message": "الكلمات"
  },
  "wreath_product_200b38ef": {
    "message": "Wreath Product"
  },
  "xi_149681d0": {
    "message": "Xi"
  },
  "yes_dde87d5": {
    "message": "نعم"
  },
  "you_are_on_a_color_palette_to_navigate_on_the_pale_227fc3a6": {
    "message": "أنت على لوحة ألوان. للتنقل في اللوحة لأعلى ويسارًا ولأسفل ويمينًا، استخدام الأزرار \"W\" و\"A\" و\"S\" و\"D\" بالترتيب"
  },
  "you_are_on_a_color_slider_to_navigate_the_slider_l_e800f68a": {
    "message": "أنت على شريط تمرير ألوان. للتنقل يسار ويمين شريط التمرير، استخدم الزرين \"A\" و\"D\" بالترتيب"
  },
  "you_are_on_an_alpha_slider_to_navigate_the_slider__3a014dc5": {
    "message": "أنت على شريط تمرير ألفا. للتنقل يسار ويمين شريط التمرير، استخدم الزرين \"A\" و\"D\" بالترتيب"
  },
  "you_have_unsaved_changes_in_the_icon_maker_tray_do_e8cf5f1b": {
    "message": "لديك تغييرات غير محفوظة في علبة صانع الأيقونات. هل ترغب في المتابعة بدون حفظ هذه التغييرات؟"
  },
  "you_may_need_to_adjust_additional_headings_to_main_975f0eee": {
    "message": "قد تحتاج إلى تعديل عناوين إضافية للحفاظ على هرمية الصفحة."
  },
  "you_may_not_upload_an_empty_file_11c31eb2": {
    "message": "لا يمكنك تحميل ملف فارغ."
  },
  "your_image_has_been_compressed_for_icon_maker_imag_2e45cd91": {
    "message": "تم ضغط صورتك لصانع الأيقونات. لن يتم ضغط الصور الأقل من { size } كيلوبايت."
  },
  "your_microphone_is_blocked_in_the_browser_settings_42af0ddc": {
    "message": "الميكروفون محظور في إعدادات المستعرض."
  },
  "your_webcam_and_microphone_are_blocked_in_the_brow_73357dc6": {
    "message": "كاميرا الويب والميكروفون محظوران في إعدادات المستعرض."
  },
  "your_webcam_is_blocked_in_the_browser_settings_7f638128": {
    "message": "كاميرا الويب محظورة في إعدادات المستعرض."
  },
  "your_webcam_may_already_be_in_use_6cd64c25": {
    "message": "قد تكون كاميرا الويب الخاصة بك قيد الاستخدام بالفعل."
  },
  "youtube_embed_url_5c1018d4": {
    "message": "عنوان URL المضمن لـ YouTube"
  },
  "zeta_5ef24f0e": {
    "message": "Zeta"
  },
  "zoom_f3e54d69": {
    "message": "Zoom"
  },
  "zoom_in_image_bb97d4f": {
    "message": "تكبير الصورة"
  },
  "zoom_out_image_d0a0a2ec": {
    "message": "تصغير الصورة"
  }
};
formatMessage.addLocale({
  ar: locale
});